import React from 'react'

const Footer = (props) => {
    return (
        <div className="tp-site-footer text-center">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="copyright">
                            <p>Copyright &copy; {new Date().getFullYear()} Iván Ariel García Auteville.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;